import React from 'react';
import { StepProps } from '../../types';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { Button } from '../ui/Button';

export const Step5Relief: React.FC<StepProps> = ({ formData, onChange, errors, t, openScheduleModal }) => {
  const data = formData.relief;
  const elections = formData.elections;

  const showQGSection = elections.transfersWithinQualifyingGroup;
  const showBRRSection = elections.businessRestructuringRelief;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-[#1a2c46] mb-6">{t('step5_title')}</h2>

      {/* Section 8.1 Transfers within a Qualifying Group */}
      {showQGSection && (
        <fieldset className="p-4 border rounded-md bg-slate-50">
          <legend className="text-md font-semibold text-[#1a2c46] px-2">{t('s8_1_transfers_qg_title')}</legend>
          {openScheduleModal && (
            <Button 
              type="button" 
              onClick={() => openScheduleModal('schedule20Relief', formData.schedule20Relief)}
              variant="secondary"
              className="mb-3 text-sm"
            >
              {t('open_schedule_button', {schedule_name: t('sch20_title')})} ({t('sch20_part_a_title')})
            </Button>
          )}
          <RadioGroup
            label={t('s8_1_adjustment_needed_label')}
            name="transfersWithinQualifyingGroupAdjustmentNeeded"
            value={data.transfersWithinQualifyingGroupAdjustmentNeeded}
            onChange={(val) => onChange('relief', 'transfersWithinQualifyingGroupAdjustmentNeeded', val)}
            options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
            error={errors.transfersWithinQualifyingGroupAdjustmentNeeded as string}
            t={t}
          />
          {data.transfersWithinQualifyingGroupAdjustmentNeeded === 'yes' && (
            <>
              <Input
                label={t('s8_1_gains_losses_relief_current_label')}
                type="text" 
                id="totalGainLossNotTaxedQGCurrentPeriod"
                name="totalGainLossNotTaxedQGCurrentPeriod"
                value={data.totalGainLossNotTaxedQGCurrentPeriod || '0.00'}
                readOnly
                className="bg-gray-100"
                error={errors.totalGainLossNotTaxedQGCurrentPeriod as string}
                placeholder={t('amount_aed_placeholder')}
                helpText={t('s8_1_transferor_note') + " " + t('s8_1_sch20a_note')}
              />
              <Input
                label={t('s8_1_gains_losses_clawback_label')}
                type="text" 
                id="totalGainLossRecognisedClawbackQG"
                name="totalGainLossRecognisedClawbackQG"
                value={data.totalGainLossRecognisedClawbackQG || '0.00'}
                readOnly
                className="bg-gray-100"
                error={errors.totalGainLossRecognisedClawbackQG as string}
                placeholder={t('amount_aed_placeholder')}
                helpText={t('s8_1_clawback_note') + " " + t('s8_1_sch20a_note')}
              />
              <Input label={t('s8_1_qg_excluded_unrealised_gains_transferee_label')} type="number" id="qgExcludedUnrealisedGainsTransferee" value={data.qgExcludedUnrealisedGainsTransferee || ''} onChange={e => onChange('relief', 'qgExcludedUnrealisedGainsTransferee', e.target.value)} error={errors.qgExcludedUnrealisedGainsTransferee as string} />
              <Input label={t('s8_1_qg_excluded_unrealised_losses_transferee_label')} type="number" id="qgExcludedUnrealisedLossesTransferee" value={data.qgExcludedUnrealisedLossesTransferee || ''} onChange={e => onChange('relief', 'qgExcludedUnrealisedLossesTransferee', e.target.value)} error={errors.qgExcludedUnrealisedLossesTransferee as string} />
              <Input label={t('s8_1_qg_realised_gains_previously_excluded_label')} type="number" id="qgRealisedGainsPreviouslyExcluded" value={data.qgRealisedGainsPreviouslyExcluded || ''} onChange={e => onChange('relief', 'qgRealisedGainsPreviouslyExcluded', e.target.value)} error={errors.qgRealisedGainsPreviouslyExcluded as string} />
              <Input label={t('s8_1_qg_realised_losses_previously_excluded_label')} type="number" id="qgRealisedLossesPreviouslyExcluded" value={data.qgRealisedLossesPreviouslyExcluded || ''} onChange={e => onChange('relief', 'qgRealisedLossesPreviouslyExcluded', e.target.value)} error={errors.qgRealisedLossesPreviouslyExcluded as string} />
              <Input label={t('s8_1_qg_depreciation_adjustment_decrease_label')} type="number" id="qgDepreciationAdjustmentDecreaseTransferee" value={data.qgDepreciationAdjustmentDecreaseTransferee || ''} onChange={e => onChange('relief', 'qgDepreciationAdjustmentDecreaseTransferee', e.target.value)} error={errors.qgDepreciationAdjustmentDecreaseTransferee as string} />
              <Input label={t('s8_1_qg_depreciation_adjustment_increase_label')} type="number" id="qgDepreciationAdjustmentIncreaseTransferee" value={data.qgDepreciationAdjustmentIncreaseTransferee || ''} onChange={e => onChange('relief', 'qgDepreciationAdjustmentIncreaseTransferee', e.target.value)} error={errors.qgDepreciationAdjustmentIncreaseTransferee as string} />
              <Input label={t('s8_1_qg_other_adjustments_clawback_increase_ti_label')} type="number" id="qgOtherAdjustmentsClawbackIncreaseTI" value={data.qgOtherAdjustmentsClawbackIncreaseTI || ''} onChange={e => onChange('relief', 'qgOtherAdjustmentsClawbackIncreaseTI', e.target.value)} error={errors.qgOtherAdjustmentsClawbackIncreaseTI as string} />
              <Input label={t('s8_1_qg_other_adjustments_clawback_decrease_ti_label')} type="number" id="qgOtherAdjustmentsClawbackDecreaseTI" value={data.qgOtherAdjustmentsClawbackDecreaseTI || ''} onChange={e => onChange('relief', 'qgOtherAdjustmentsClawbackDecreaseTI', e.target.value)} error={errors.qgOtherAdjustmentsClawbackDecreaseTI as string} />
              <Input label={t('s8_1_qg_other_adjustments_desc_label')} type="text" id="qgOtherAdjustmentsDesc" value={data.qgOtherAdjustmentsDesc || ''} onChange={e => onChange('relief', 'qgOtherAdjustmentsDesc', e.target.value)} error={errors.qgOtherAdjustmentsDesc as string} />
            </>
          )}
        </fieldset>
      )}

      {/* Section 8.2 Business Restructuring Relief */}
      {showBRRSection && (
         <fieldset className="p-4 border rounded-md bg-slate-50">
          <legend className="text-md font-semibold text-[#1a2c46] px-2">{t('s8_2_business_restructuring_title')}</legend>
          {openScheduleModal && (
            <Button 
              type="button" 
              onClick={() => openScheduleModal('schedule20Relief', formData.schedule20Relief)}
              variant="secondary"
              className="mb-3 text-sm"
            >
              {t('open_schedule_button', {schedule_name: t('sch20_title')})} ({t('sch20_part_b_title')})
            </Button>
          )}
           <RadioGroup
            label={t('s8_2_adjustment_needed_label')}
            name="businessRestructuringReliefAdjustmentNeeded"
            value={data.businessRestructuringReliefAdjustmentNeeded}
            onChange={(val) => onChange('relief', 'businessRestructuringReliefAdjustmentNeeded', val)}
            options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
            error={errors.businessRestructuringReliefAdjustmentNeeded as string}
            t={t}
          />
          {data.businessRestructuringReliefAdjustmentNeeded === 'yes' && (
            <>
              <Input
                label={t('s8_2_gains_losses_relief_current_label')}
                type="text" 
                id="totalGainLossNotTaxedBRRCurrentPeriod"
                name="totalGainLossNotTaxedBRRCurrentPeriod"
                value={data.totalGainLossNotTaxedBRRCurrentPeriod || '0.00'}
                readOnly
                className="bg-gray-100"
                error={errors.totalGainLossNotTaxedBRRCurrentPeriod as string}
                placeholder={t('amount_aed_placeholder')}
                helpText={t('s8_2_transferor_note') + " " + t('s8_2_sch20b_note')}
              />
              <Input
                label={t('s8_2_gains_losses_clawback_label')}
                type="text" 
                id="totalGainLossRecognisedClawbackBRR"
                name="totalGainLossRecognisedClawbackBRR"
                value={data.totalGainLossRecognisedClawbackBRR || '0.00'}
                readOnly
                className="bg-gray-100"
                error={errors.totalGainLossRecognisedClawbackBRR as string}
                placeholder={t('amount_aed_placeholder')}
                helpText={t('s8_2_clawback_note') + " " + t('s8_2_sch20b_note')}
              />
              <Input label={t('s8_2_brr_excluded_unrealised_gains_transferee_label')} type="number" id="brrExcludedUnrealisedGainsTransferee" value={data.brrExcludedUnrealisedGainsTransferee || ''} onChange={e => onChange('relief', 'brrExcludedUnrealisedGainsTransferee', e.target.value)} error={errors.brrExcludedUnrealisedGainsTransferee as string} />
              <Input label={t('s8_2_brr_excluded_unrealised_losses_transferee_label')} type="number" id="brrExcludedUnrealisedLossesTransferee" value={data.brrExcludedUnrealisedLossesTransferee || ''} onChange={e => onChange('relief', 'brrExcludedUnrealisedLossesTransferee', e.target.value)} error={errors.brrExcludedUnrealisedLossesTransferee as string} />
              <Input label={t('s8_2_brr_realised_gains_previously_excluded_label')} type="number" id="brrRealisedGainsPreviouslyExcluded" value={data.brrRealisedGainsPreviouslyExcluded || ''} onChange={e => onChange('relief', 'brrRealisedGainsPreviouslyExcluded', e.target.value)} error={errors.brrRealisedGainsPreviouslyExcluded as string} />
              <Input label={t('s8_2_brr_realised_losses_previously_excluded_label')} type="number" id="brrRealisedLossesPreviouslyExcluded" value={data.brrRealisedLossesPreviouslyExcluded || ''} onChange={e => onChange('relief', 'brrRealisedLossesPreviouslyExcluded', e.target.value)} error={errors.brrRealisedLossesPreviouslyExcluded as string} />
              <Input label={t('s8_2_brr_depreciation_adjustment_decrease_label')} type="number" id="brrDepreciationAdjustmentDecreaseTransferee" value={data.brrDepreciationAdjustmentDecreaseTransferee || ''} onChange={e => onChange('relief', 'brrDepreciationAdjustmentDecreaseTransferee', e.target.value)} error={errors.brrDepreciationAdjustmentDecreaseTransferee as string} />
              <Input label={t('s8_2_brr_depreciation_adjustment_increase_label')} type="number" id="brrDepreciationAdjustmentIncreaseTransferee" value={data.brrDepreciationAdjustmentIncreaseTransferee || ''} onChange={e => onChange('relief', 'brrDepreciationAdjustmentIncreaseTransferee', e.target.value)} error={errors.brrDepreciationAdjustmentIncreaseTransferee as string} />
              <Input label={t('s8_2_brr_other_adjustments_clawback_increase_ti_label')} type="number" id="brrOtherAdjustmentsClawbackIncreaseTI" value={data.brrOtherAdjustmentsClawbackIncreaseTI || ''} onChange={e => onChange('relief', 'brrOtherAdjustmentsClawbackIncreaseTI', e.target.value)} error={errors.brrOtherAdjustmentsClawbackIncreaseTI as string} />
              <Input label={t('s8_2_brr_other_adjustments_clawback_decrease_ti_label')} type="number" id="brrOtherAdjustmentsClawbackDecreaseTI" value={data.brrOtherAdjustmentsClawbackDecreaseTI || ''} onChange={e => onChange('relief', 'brrOtherAdjustmentsClawbackDecreaseTI', e.target.value)} error={errors.brrOtherAdjustmentsClawbackDecreaseTI as string} />
              <Input label={t('s8_2_brr_other_adjustments_desc_label')} type="text" id="brrOtherAdjustmentsDesc" value={data.brrOtherAdjustmentsDesc || ''} onChange={e => onChange('relief', 'brrOtherAdjustmentsDesc', e.target.value)} error={errors.brrOtherAdjustmentsDesc as string} />
            </>
          )}
        </fieldset>
      )}
      
      {!showQGSection && !showBRRSection && (
        <p className="text-sm text-gray-500">{t('s8_no_reliefs_selected_note')}</p>
      )}

      <p className="mt-4 text-sm text-gray-600">{t('step5_note')}</p>
      {formData.elections.smallBusinessRelief && (
         <p className="mt-2 p-3 bg-yellow-50 border border-yellow-200 text-yellow-700 rounded-md text-sm">
           {t('sbr_skip_note')}
         </p>
      )}
    </div>
  );
};